import script from "./ArticlePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePopover.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePopover.vue?vue&type=style&index=0&id=b5df3066&lang=css"
import "./ArticlePopover.vue?vue&type=style&index=1&id=b5df3066&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5df3066"]])

export default __exports__